import { DayOfWeek } from "@gymflow/types";

export const getDayOfWeekFromMoment = (
  momentDate: moment.Moment,
): DayOfWeek => {
  const dayMap: { [key: number]: DayOfWeek } = {
    1: "MONDAY",
    2: "TUESDAY",
    3: "WEDNESDAY",
    4: "THURSDAY",
    5: "FRIDAY",
    6: "SATURDAY",
    0: "SUNDAY",
  };

  return dayMap[momentDate.day()];
};
